var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgVectorWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 817,
    viewBox: "0 0 1440 817",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M-69.274 251.492L-195.393 550.856C-231.575 636.739 -200.522 736.197 -121.901 786.235C-46.4654 834.245 52.1779 823.519 115.532 760.418L324.155 552.624C367.573 509.379 425.21 483.363 486.362 479.406L1401.62 420.19C1460.12 416.405 1515.5 392.422 1558.27 352.338L1655.56 261.179C1686.08 232.583 1703.35 192.594 1703.24 150.772C1702.85 3.70064 1513.63 -55.818 1429.12 64.5455L1371.38 146.768C1332.58 202.028 1266.46 231.373 1199.45 223.071L194.984 98.6368C82.6181 84.7168 -25.3152 147.149 -69.274 251.492Z",
    fill: "#EE6A29",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgVectorWave);
export default __webpack_public_path__ + "static/media/bg-vector-wave.e318108c920ce7a1d27399f6f0b8e7d9.svg";
export { ForwardRef as ReactComponent };